import type {ColumnDef} from "@tanstack/react-table";
import {DateElement} from "../../common/uiElements/DateElement";

type ReservationUpdatedRow = {
    updateDate?: Date;
};

export const createReservationUpdatedColumn = <TData extends ReservationUpdatedRow>(
    header: string,
): ColumnDef<TData> => ({
    id: "updateDate",
    header,
    accessorFn: row => row.updateDate,
    cell: ({row}) => <DateElement date={row.original.updateDate}/>,
    size: 190,
    meta: {
        defaultActive: false,
        isServerSortable: true,
        printable: true,
        printCell: row => <DateElement date={row.original.updateDate}/>,
    },
});
